import { Component, EventEmitter, Output } from '@angular/core';
import { ButtonComponent } from '@shared/components/button/button.component';
import { SharedModule } from '@shared/modules/shared.module';
import { PhoneFormatPipe } from '@shared/pipes/phone-format/phone-format.pipe';
import type { UserRow } from '../user-row.model';

@Component({
	selector: 'app-user-detail',
	imports: [SharedModule, ButtonComponent, PhoneFormatPipe],
	templateUrl: './user-detail.component.html',
	styleUrl: './user-detail.component.scss',
})
export class UserDetailComponent {
	@Output() editRequested = new EventEmitter<UserRow>();
	@Output() blockRequested = new EventEmitter<UserRow>();
	@Output() unbanRequested = new EventEmitter<UserRow>();
	@Output() deletePermanentlyRequested = new EventEmitter<UserRow>();

	visible = false;
	user: UserRow | null = null;

	show(user: UserRow): void {
		this.user = user;
		// Use setTimeout to ensure proper dialog opening
		setTimeout(() => {
			this.visible = true;
		}, 0);
	}

	onEdit(): void {
		this.visible = false;
		if (this.user) this.editRequested.emit(this.user);
	}

	onBlock(): void {
		this.visible = false;
		if (this.user) this.blockRequested.emit(this.user);
	}

	onUnban(): void {
		this.visible = false;
		if (this.user) this.unbanRequested.emit(this.user);
	}

	onDeletePermanently(): void {
		this.visible = false;
		if (this.user) this.deletePermanentlyRequested.emit(this.user);
	}
}
